import { apiClient } from './api';

/**
 * CSRF Token Service
 * Manages CSRF token fetching and storage for state-changing requests
 */
class CsrfService {
  private token: string | null = null;
  private fetching: Promise<void> | null = null;

  /**
   * Fetch CSRF token from the backend
   * Prevents concurrent fetches using a promise lock
   */
  async fetchToken(): Promise<void> {
    // Prevent concurrent fetches
    if (this.fetching) {
      return this.fetching;
    }

    this.fetching = apiClient
      .get<{ csrfToken: string }>('/csrf/token')
      .then((data) => {
        this.token = data.csrfToken;
      })
      .catch((err) => {
        console.error('Failed to fetch CSRF token:', err);
        this.token = null;
      })
      .finally(() => {
        this.fetching = null;
      });

    return this.fetching;
  }

  /**
   * Get the current CSRF token
   * Returns null if no token has been fetched
   */
  getToken(): string | null {
    return this.token;
  }

  /**
   * Clear the stored CSRF token
   * Should be called on logout
   */
  clearToken(): void {
    this.token = null;
  }
}

export const csrfService = new CsrfService();
